var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "forgot-container",
      on: {
        keyup: function($event) {
          _vm.changed = true
        },
        change: function($event) {
          _vm.changed = true
        }
      }
    },
    [
      !_vm.success
        ? _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _c("error-list", { attrs: { messages: _vm.errors.items } }),
              _vm._v(" "),
              _c(
                "f9field",
                [
                  _c(
                    "span",
                    {
                      staticClass: "slider-label",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [
                      _vm._v("\n                Email Address or "),
                      _c("i", [_vm._v("FRONTIER")]),
                      _vm._v(" Miles"),
                      _c("small", [_vm._v("sm")]),
                      _vm._v(" #\n            ")
                    ]
                  ),
                  _vm._v(" "),
                  _c("f9input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "slider-input",
                    attrs: {
                      saved: !_vm.changed,
                      autocomplete: "off",
                      "data-vv-scope": _vm.validationScope,
                      name: "email",
                      "aria-label": "Forgot Password User Name",
                      value: "",
                      type: "text"
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.formInput,
                      callback: function($$v) {
                        _vm.formInput = $$v
                      },
                      expression: "formInput"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "f9button",
                {
                  ref: "submitButton",
                  attrs: { disabled: _vm.disableSubmitButton },
                  on: { click: _vm.submit }
                },
                [_vm._v("\n            Reset\n        ")]
              )
            ],
            1
          )
        : _c("div", [_vm._m(1)])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "forgot-text" }, [
      _vm._v("Please enter your email address / "),
      _c("i", [_vm._v("FRONTIER")]),
      _vm._v(" Miles"),
      _c("small", [_vm._v("sm")]),
      _vm._v(
        " # below and we will send you an email containing a temporary password. Please make sure you are using the email address associated with your account."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "forgot-password-successful-header" }, [
        _vm._v(
          "\n                If the email address or Frontier number you submitted is associated with your "
        ),
        _c("i", [_vm._v("FRONTIER")]),
        _vm._v(" Miles"),
        _c("small", [_vm._v("sm")]),
        _vm._v(
          " account then you will receive a temporary password.\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5df8a14c", { render: render, staticRenderFns: staticRenderFns })
  }
}